import axios from "axios";
import * as client from "../ClientConsumer";

export const UPDATE_AVATAR_URL = "/v1/community/user/avatar";

const routes = {
    UPDATE_PROFILE_DETAILS: "/user/profile",
    UPDATE_AVATAR: "/user/avatar",
    DELETE_PROFILE: "/user/profile/deactivate",
};

export async function checkAvatar(url: string | undefined): Promise<any> {
    if (!url) {
        return false;
    }
    return await axios
        .get(url)
        .then(() => true)
        .catch(() => false);
}

export async function updateProfile(newData = {}): Promise<string> {
    return client
        .putData(routes.UPDATE_PROFILE_DETAILS, newData)
        .then((response) => {
            return response.data.message;
        });
}

export function deleteProfile() {
    return client.postData(routes.DELETE_PROFILE, {}).then((res) => res.data);
}

export async function updateAvatar(blob: Blob): Promise<any> {
    const formData = new FormData();
    formData.append("media", blob);
    return client
        .postImageData(routes.UPDATE_AVATAR, formData)
        .then((response) => {
            return response.data;
        });
}
export function deleteAvatar(): Promise<any> {
    return client.deleteData(routes.UPDATE_AVATAR).then((response) => {
        return response.data;
    });
}
